'use client';

import { cn } from '@bridebook/aura';
import { useRoundedModalContainerContext } from './rounded-modal-container-context';
import { cva } from 'class-variance-authority';

const roundedModalFooterVariants = cva('', {
  variants: {
    width: {
      'responsive-sm':
        'flex flex-col justify-center gap-3 px-10 pt-4 pb-6 lg:flex-row-reverse lg:pb-8',
      sm: 'flex flex-col justify-center gap-3 px-10 pt-4 pb-6',
      standard: 'flex justify-center gap-3 px-10 pt-4 pb-8',
      lg: 'flex justify-center gap-3 px-10 pt-4 pb-8',
    },
  },
});

export const RoundedModalFooter = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const { width } = useRoundedModalContainerContext();
  return (
    <div
      data-slot="rounded-modal-footer"
      className={cn(roundedModalFooterVariants({ width }), className)}
      {...props}
    />
  );
};
